import http from '../jslibs/axios/http'
import dkAxiosFile from '@/jslibs/axios/axios-file'
import baseURL from '@/configs/baseUrl'

export const login = data => http.post('/v1/cms/Login', data)

// 获取所有菜单项
export const menulist = () => http.get('/v1/cms/AdminAuthMenuTree')

// 获取所有行业名称列表
export const areaList = () => http.get('/cms/unit/region')

// 获取七牛信息
export const qiniuInfo = () => http.get('/cms/Communal')

export const changeSetting = (uuid, data) => http.put(`/cms/SystemSetting/${uuid}`, data)

export const getAreaList = () => http.get('/v1/app/Area')
// 上传图片
// export const uploadImg = (data)=> http.post('http(s)://upload-z2.qiniup.com', data)

export const uploadFile = data => dkAxiosFile({
    url: '/v1/app/UploadFile',
    headers: {
        'content-type': 'multipart/form-data'
    },
    method: 'POST',
    data
})

export const importProduct = data => dkAxiosFile({
    url: '/cms/excel/importProduct',
    headers: {
        'content-type': 'multipart/form-data'
    },
    method: 'POST',
    data
})

export const getUEditor = () => http.get('/v1/cms/UEUpload')
export const UEUpload = baseURL + '/v1/cms/UEUpload'
